import CONSTANTS from '../CONSTANTS';

/**
 * @typedef {Object} DoctorsPagination
 * @property {number} _page        - Current zero-based page index.
 * @property {number} _limit       - Page size used in the request.
 * @property {number} _total_pages - Total number of available pages.
 */

/**
 * @typedef {Object} DoctorsState
 * @property {{ users: Object[], pagination: DoctorsPagination }} doctors - Paginated doctor list.
 * @property {Object} editData - Doctor object currently being edited.
 */

/** @type {DoctorsState} */
const initialState = {
  doctors: {
    users: [],
    pagination: {
      _page: 0,
      _limit: 10,
      _total_pages: 0,
    },
  },
  editData: {},
};

/**
 * Reducer for the doctor management slice.
 *
 * @param {DoctorsState} state
 * @param {Object} action
 * @returns {DoctorsState}
 */
const usersDoctorReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.USERS_DOCTOR_SET_LIST:
      return { ...state, doctors: action.doctors };
    case CONSTANTS.USERS_DOCTOR_SET_EDIT_DATA:
      return { ...state, editData: action.data };
    default:
      return state;
  }
};

export default usersDoctorReducer;